export const ENDPOINT_CONSTANTS = {
  AUTHENTICATE: 'Authenticate',
  REFRESH_TOKEN: 'RefreshToken',
  LOGOUT: 'LogOut',
  UPLOAD_DOCUMENT: 'UploadDocument',
  UPLOAD_CHUNK: 'UploadChunk',
  SAVE_CHAT: 'SaveChat',
  CHATBOT_RESPONSE: 'ChatBotResponse',
  CHATBOT_RESPONSE_STREAM: 'ChatBotResponseStream',
  CHATBOT_TEST_STREAM: 'stream-responses',
  GET_CHAT_HISTORY: 'GetChatHistory',
  UPDATE_CHAT: 'UpdateChat',
  GET_CHAT_HISTORY_BY_CHAT_ID: 'GetChatHistoryByChatId',
  GET_ACTIVE_CHAT_HISTORY: 'GetActiveChatHistory',
  DELETE_CHAT: 'DeleteChatHistory',
  GET_ALL_FEEDBACKS: 'GetAllFeedbacks',
  RESOLVE_FEEDBACK: 'ResolveFeedback',
  GET_COLLECTIONS: 'GetCollections',
  UPDATE_TEXT: 'UpdateText',
  DELETE_TEXT: 'DeleteText',
  DELETE_DOCUMENT:'DeleteDocumentCollection',
  RESET_PASSWORD:'ResetPassword',
  FORGOT_PASSWORD:'forgot-password',
  GET_MY_TENANTS: 'Tenants',
  DOWNLOAD_DOCUMENT:'DownloadDocument',
  GET_KNOWLEDGE_GRAPH:'GetKnowledgeGraph',
  GET_ALL_DOCUMENTS: 'GetDocuments',
  GET_GRAPH_DOCUMENTS: 'GetGraphDocuments',
  GET_INFERENCES: 'GetInferences',
  SYNC_INFERENCES: 'SyncInferences',
  GENERATE_INFERENCES: 'GenerateInferences',
  CLUSTERIZE: 'Clusterize',
  GET_CLUSTERS: 'Clusters',
  GET_CLUSTER_CHUNKS: 'Chunks',
  MEMBERS: 'Members',
  ACCEPTED_ORGANOGRAM_ROLES: 'AcceptedOrganogramRoles',
  ME_ORGANOGRAM_ROLE: 'Me/OrganogramRole',
  LEAVE_BALANCE: 'Balance',
  LEAVE_MY_REQUESTS: 'MyRequests',
  LEAVE_TEAM_REQUESTS: 'TeamRequests',
  LEAVE_REQUESTS: 'Requests',
  LEAVE_ME_SYSTEM_ROLE: 'Me/SystemRole',
  LEAVE_ATTACHMENT: 'Attachment'
} as const;
